export const GATE_STYLE = {
  PASS: { label: "LOLOS", cls: "bg-green-100 text-green-800 border-green-300" },
  BLOCKED: { label: "DIBLOKIR", cls: "bg-red-100 text-red-800 border-red-300" },
};

export const RISK_LEVEL_STYLE = {
  Tinggi: "bg-red-100 text-red-800 border-red-300",
  Sedang: "bg-amber-100 text-amber-800 border-amber-300",
  Rendah: "bg-green-100 text-green-800 border-green-300",
};

export const LIKELIHOOD = ["Rendah", "Sedang", "Tinggi"];

export const PROC_TYPES = ["Substantif", "Uji Pengendalian", "Prosedur Analitis"];

export const RISK_STATUS = ["Draft", "Direviu", "Disetujui"];
